import { Params } from '@angular/router';
import { Injectable } from '@angular/core';
import { NameValue } from '../interfaces/WidgetInterfaces';
import { CustomMenu } from '../interfaces/DisplayInterfaces';

@Injectable()
export class ClientSettingsService {
        WebApiUrl: string;
        RedirectUrlSuffix: string;
        ApplicationName;
        ConsoleLogLevel = 4;  // 0 = off, 1 = error, 2 = warning, 3 = major, 4 = minor, 5 = trace
        AppLogLevel = 3;
        ThemePaths: NameValue[] = [];
        CurrentTheme: string;
        HideLayoutMenu = false;
        HideCacheMenu = false;
        HideWidgetTabs = false;
        HidePrintLayout = false;
        SkipAuthentication = false;
        instance: string;    
        clientId: string;
        cacheLocation: string;
        expireOffsetSeconds: number;
        VersionInfo: NameValue[] = [];
        CustomMenus?: CustomMenu[];
        GlobalConfigurationItems?: Params; //Simple mechanism for app and feature modules consuming the library to share configuration values, i.e. from environment.ts
}
